module.exports = __webpack_public_path__ + "static/img/ava1.cd78fffc.png";